// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-animation-theme {
  visibility: hidden;
  display: block;
  position: absolute;
  z-index: -100;
}

.cesium-animation-themeNormal {
  color: #222;
}

.cesium-animation-themeHover {
  color: #4488b0;
}

.cesium-animation-themeSelect {
  color: #242;
}

.cesium-animation-themeDisabled {
  color: #333;
}

.cesium-animation-themeKnob {
  color: #222;
}

.cesium-animation-themePointer {
  color: #2e2;
}

.cesium-animation-themeSwoosh {
  color: #8ac;
}

.cesium-animation-themeSwooshHover {
  color: #aef;
}

.cesium-animation-svgText {
  fill: #edffff;
  font-family: Sans-Serif;
  font-size: 15px;
  text-anchor: middle;
}

.cesium-animation-blank {
  fill: #000;
  fill-opacity: 0.01; /* This must be clickable, so it can't be 'fill: none'. */
  stroke: none;
}

.cesium-animation-rectButton {
  cursor: pointer;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cesium-animation-rectButton .cesium-animation-buttonGlow {
  fill: #fff;
  stroke: none;
  /* Widget will add: filter: url(#animation_blurred); */
  display: none;
}

.cesium-animation-rectButton:hover .cesium-animation-buttonGlow {
  display: block;
}

.cesium-animation-rectButton .cesium-animation-buttonPath {
  fill: #edffff;
}

.cesium-animation-rectButton .cesium-animation-buttonMain {
  /* Widget will add: fill: url(#animation_buttonNormal); */
  stroke: #444;
  stroke-width: 1.2;
}

.cesium-animation-rectButton:hover .cesium-animation-buttonMain {
  /* Widget will add: fill: url(#animation_buttonHovered); */
  stroke: #aef;
}

.cesium-animation-rectButton:active .cesium-animation-buttonMain {
  fill: #abd6ff;
}

.cesium-animation-buttonDisabled {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cesium-animation-buttonDisabled .cesium-animation-buttonMain {
  /* Widget will add: fill: url(#animation_buttonDisabled); */
  stroke: #555;
}

.cesium-animation-buttonDisabled .cesium-animation-buttonPath {
  fill: #818181;
}

.cesium-animation-buttonDisabled .cesium-animation-buttonGlow {
  display: none;
}

.cesium-animation-buttonToggled .cesium-animation-buttonGlow {
  display: block;
  fill: #2e2;
}

.cesium-animation-buttonToggled .cesium-animation-buttonMain {
  stroke: #2e2;
}

.cesium-animation-buttonToggled:hover .cesium-animation-buttonGlow {
  fill: #fff;
}

.cesium-animation-buttonToggled:hover .cesium-animation-buttonMain {
  stroke: #2e2;
}

.cesium-animation-shuttleRingG {
  cursor: pointer;
}

/* Widget will add:
.cesium-animation-shuttleRingG .cesium-animation-shuttleRingSwoosh {
    fill: url(#animation_shuttleRingSwooshGradient);
}

.cesium-animation-shuttleRingG:hover .cesium-animation-shuttleRingSwoosh {
    fill: url(#animation_shuttleRingSwooshHovered);
}
*/

.cesium-animation-shuttleRingPointer {
  /* Widget will add: fill: url(#animation_shuttleRingPointerGradient); */
  cursor: pointer;
}

.cesium-animation-shuttleRingPausePointer {
  /* Widget will add: fill: url(#animation_shuttleRingPointerPaused); */
  cursor: pointer;
}

.cesium-animation-shuttleRingBack {
  fill: #181818;
  fill-opacity: 0.8;
  stroke: #333;
  stroke-width: 1.2;
}

.cesium-animation-shuttleRingSwoosh line {
  stroke: #8ac;
  stroke-width: 3;
  stroke-opacity: 0.2;
  stroke-linecap: round;
}

.cesium-animation-knobOuter {
  /* Widget will add: fill: url(#animation_knobOuter); */
  cursor: pointer;
  stroke: #444;
  stroke-width: 1.2;
}

.cesium-animation-knobInner {
  /* Widget will add: fill: url(#animation_knobInner); */
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/Animation/Animation.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB,EAAE,yDAAyD;EAC7E,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sDAAsD;EACtD,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAyD;EACzD,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;CAQC;;AAED;EACE,uEAAuE;EACvE,eAAe;AACjB;;AAEA;EACE,qEAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sDAAsD;EACtD,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;EACtD,eAAe;AACjB","sourcesContent":[".cesium-animation-theme {\n  visibility: hidden;\n  display: block;\n  position: absolute;\n  z-index: -100;\n}\n\n.cesium-animation-themeNormal {\n  color: #222;\n}\n\n.cesium-animation-themeHover {\n  color: #4488b0;\n}\n\n.cesium-animation-themeSelect {\n  color: #242;\n}\n\n.cesium-animation-themeDisabled {\n  color: #333;\n}\n\n.cesium-animation-themeKnob {\n  color: #222;\n}\n\n.cesium-animation-themePointer {\n  color: #2e2;\n}\n\n.cesium-animation-themeSwoosh {\n  color: #8ac;\n}\n\n.cesium-animation-themeSwooshHover {\n  color: #aef;\n}\n\n.cesium-animation-svgText {\n  fill: #edffff;\n  font-family: Sans-Serif;\n  font-size: 15px;\n  text-anchor: middle;\n}\n\n.cesium-animation-blank {\n  fill: #000;\n  fill-opacity: 0.01; /* This must be clickable, so it can't be 'fill: none'. */\n  stroke: none;\n}\n\n.cesium-animation-rectButton {\n  cursor: pointer;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cesium-animation-rectButton .cesium-animation-buttonGlow {\n  fill: #fff;\n  stroke: none;\n  /* Widget will add: filter: url(#animation_blurred); */\n  display: none;\n}\n\n.cesium-animation-rectButton:hover .cesium-animation-buttonGlow {\n  display: block;\n}\n\n.cesium-animation-rectButton .cesium-animation-buttonPath {\n  fill: #edffff;\n}\n\n.cesium-animation-rectButton .cesium-animation-buttonMain {\n  /* Widget will add: fill: url(#animation_buttonNormal); */\n  stroke: #444;\n  stroke-width: 1.2;\n}\n\n.cesium-animation-rectButton:hover .cesium-animation-buttonMain {\n  /* Widget will add: fill: url(#animation_buttonHovered); */\n  stroke: #aef;\n}\n\n.cesium-animation-rectButton:active .cesium-animation-buttonMain {\n  fill: #abd6ff;\n}\n\n.cesium-animation-buttonDisabled {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.cesium-animation-buttonDisabled .cesium-animation-buttonMain {\n  /* Widget will add: fill: url(#animation_buttonDisabled); */\n  stroke: #555;\n}\n\n.cesium-animation-buttonDisabled .cesium-animation-buttonPath {\n  fill: #818181;\n}\n\n.cesium-animation-buttonDisabled .cesium-animation-buttonGlow {\n  display: none;\n}\n\n.cesium-animation-buttonToggled .cesium-animation-buttonGlow {\n  display: block;\n  fill: #2e2;\n}\n\n.cesium-animation-buttonToggled .cesium-animation-buttonMain {\n  stroke: #2e2;\n}\n\n.cesium-animation-buttonToggled:hover .cesium-animation-buttonGlow {\n  fill: #fff;\n}\n\n.cesium-animation-buttonToggled:hover .cesium-animation-buttonMain {\n  stroke: #2e2;\n}\n\n.cesium-animation-shuttleRingG {\n  cursor: pointer;\n}\n\n/* Widget will add:\n.cesium-animation-shuttleRingG .cesium-animation-shuttleRingSwoosh {\n    fill: url(#animation_shuttleRingSwooshGradient);\n}\n\n.cesium-animation-shuttleRingG:hover .cesium-animation-shuttleRingSwoosh {\n    fill: url(#animation_shuttleRingSwooshHovered);\n}\n*/\n\n.cesium-animation-shuttleRingPointer {\n  /* Widget will add: fill: url(#animation_shuttleRingPointerGradient); */\n  cursor: pointer;\n}\n\n.cesium-animation-shuttleRingPausePointer {\n  /* Widget will add: fill: url(#animation_shuttleRingPointerPaused); */\n  cursor: pointer;\n}\n\n.cesium-animation-shuttleRingBack {\n  fill: #181818;\n  fill-opacity: 0.8;\n  stroke: #333;\n  stroke-width: 1.2;\n}\n\n.cesium-animation-shuttleRingSwoosh line {\n  stroke: #8ac;\n  stroke-width: 3;\n  stroke-opacity: 0.2;\n  stroke-linecap: round;\n}\n\n.cesium-animation-knobOuter {\n  /* Widget will add: fill: url(#animation_knobOuter); */\n  cursor: pointer;\n  stroke: #444;\n  stroke-width: 1.2;\n}\n\n.cesium-animation-knobInner {\n  /* Widget will add: fill: url(#animation_knobInner); */\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
